import { render, staticRenderFns } from "./Resume.vue?vue&type=template&id=0a3ec1f6&scoped=true&"
import script from "./Resume.vue?vue&type=script&lang=js&"
export * from "./Resume.vue?vue&type=script&lang=js&"
import style0 from "./Resume.vue?vue&type=style&index=0&id=0a3ec1f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3ec1f6",
  null
  
)

export default component.exports